import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import InviteSubscribersModal from './subscribers/InviteSubscribersModal';
import Colors from '../../../styles/colors';
import { ActionButton, OrangeSubmitButton } from '../../../components/buttons/buttons';
import SoundcastsTabs from '../../../components/soundcasts_tabs';
import { canUserAccessFeature, getSoundcastsManagedv2 } from '../../../helpers/userinfoHelper';
import { ALERTS } from '../../../helpers/texts';
import SoundcastBundleDraggable from './managed/SoundcastBundleDraggable';
import { getOrderFromProps, reorderInArray, createOrderedBundles } from './managed/sorting_utils';

const getDraggableListStyle = isDraggingOver => ({
  // background: isDraggingOver ? "lightblue" : "lightgrey",
});

export default class SoundcastsBundles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      soundcasts: [],
      showModal: false,
      currentSoundcastID: '',
      currentSoundcast: null,
      showStatsModal: false,
      currentEpisode: null,
      modal: {
        show: false,
        title: '',
        content: '',
        actionLabel: 'Change Plan',
        onClose: () => {},
        upgrade: false,
      },
    };

    this.onDragEnd = this.onDragEnd.bind(this);
    this.editSoundcast = this.editSoundcast.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleSoundcastSignup = this.handleSoundcastSignup.bind(this);
    this.handleStatsModal = this.handleStatsModal.bind(this);
    this.deleteSoundcast = this.deleteSoundcast.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const soundcastsManaged = getSoundcastsManagedv2(soundcast => soundcast.bundle);
    const soundcasts =  createOrderedBundles(soundcastsManaged, getOrderFromProps(nextProps));
  
    return {
      soundcasts,
    };
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    // dropped in the same place
    if (result.source.index === result.destination.index) {
      return;
    }

    const soundcasts = reorderInArray(
      this.state.soundcasts,
      result.source.index,
      result.destination.index
    );

    this.setState({
      soundcasts,
    });

    const { userInfo } = this.props;
    this.props.updateManagedBundlesOrderCreator({
      publisherID: userInfo.publisherID,
      soundcasts,
    });
  }

  editSoundcast(soundcastId, soundcast) {
    const { history } = this.props;
    history.push({
      pathname: `/dashboard/edit_bundle/${soundcastId}`,
      state: {
        id: soundcastId,
        bundle: soundcast,
      },
    });
  }

  goToSoundcastSignup(soundcastId) {
    window.open(`/signup/soundcast_user/${soundcastId}`);
  }

  handleSoundcastSignup(soundcast) {
    return () => {
      if (!canUserAccessFeature('NON_PAYMENT_ACCESS_LINK')) {
        return this.showAlertModal({
          title: 'Upgrade Required',
          content: ALERTS().NON_PAYMENT_ACCESS_LINK.NO_ACCESS,
          upgrade: true,
        });
      }

      this.goToSoundcastSignup(soundcast.id);
    };
  }

  handleModal(soundcast) {
    // console.log('handleModal called');
    if (!this.state.showModal) {
      this.setState({
        showModal: true,
        currentSoundcastID: soundcast.id,
        currentSoundcast: soundcast,
      });
    } else {
      this.setState({ showModal: false });
    }
  }

  handleStatsModal() {
    this.setState({ showStatsModal: !this.state.showStatsModal });
  }

  async deleteSoundcast(soundcastId) {
    let { userInfo } = this.props;
    const soundcastTitle = userInfo.soundcasts_managed[soundcastId].title;
    const confirmText = `Are you sure you want to delete ${soundcastTitle}? All information about this soundcast will be deleted, including subscribers' emails and audio files.`;
    if (confirm(confirmText)) {
      // delete the data from both firebase and postgres
      Axios.post('/api/delete_soundcast', {
        soundcastId,
        publisherId: userInfo.publisherID,
      }).then(() => {
        this.showAlertModal({
          content: 'Soundcast bundle has been successfully deleted.',
          alertOnly: true,
        });
      });
    }
  }

  alertModalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      subscribe = false,
      upgrade = false,
      alertOnly = false,
      onClose = false,
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState(
        {
          modal: {
            ...this.state.modal,
            show,
            title,
            content,
            subscribe,
            upgrade,
            alertOnly,
            onClose: !show ? false : onClose,
          },
        },
        () => oldClose && !show && oldClose()
      );
    };
  }

  showAlertModal(metadata = {}) {
    this.alertModalHandler({
      show: true,
      ...metadata,
    })();
  }

  renderAlertModal() {
    const { show, title, content, subscribe, upgrade, alertOnly } = this.state.modal;
    const actionBtnLabel = upgrade ? 'Upgrade' : subscribe ? 'Subscribe' : 'OK';
    const actionBtnClick =
      upgrade || subscribe
        ? () => this.props.history.push('/pricing')
        : this.alertModalHandler({ show: false });
    const actions = [
      <div style={{ textAlign: 'center', padding: 20 }}>
        <ActionButton onClick={actionBtnClick}>{actionBtnLabel}</ActionButton>
        {!alertOnly && (
          <ActionButton
            textColor="#f76b1c"
            backgroundColor="#fff"
            onClick={this.alertModalHandler({ show: false })}>
            Cancel
          </ActionButton>
        )}
      </div>,
    ];

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
            <div
              style={{ cursor: 'pointer', float: 'right', fontSize: 29 }}
              onClick={this.alertModalHandler({ show: false })}>
              &#10799; {/* Close button (X) */}
            </div>
          </div>
        }
        actions={actions}
        modal={false}
        open={show}
        onRequestClose={this.alertModalHandler({ show: false })}>
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  render() {
    const { userInfo, history } = this.props;
    const { soundcasts = [] } = this.state;

    return (
      <div style={{ minHeight: 700 }}>
        <InviteSubscribersModal
          isShown={this.state.showModal}
          soundcast={this.state.currentSoundcast}
          onClose={this.handleModal}
          userInfo={userInfo}
        />
        <SoundcastsTabs active="bundles" />

        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getDraggableListStyle(snapshot.isDraggingOver)}>
                {soundcasts.map((soundcast, index) => {
                  return (
                    <SoundcastBundleDraggable
                      key={`bundle-${soundcast.id}`}
                      index={index}
                      soundcast={soundcast}
                      onNonPaymentSignup={this.handleSoundcastSignup(soundcast)}
                      onEdit={() => this.editSoundcast(soundcast.id, soundcast)}
                      onDelete={() => this.deleteSoundcast(soundcast.id)}
                    />
                  );
                })}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <div className="row" style={{ ...styles.row, backgroundColor: 'transparent' }}>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <OrangeSubmitButton
              label="Create New Bundle"
              onClick={() => {
                if (Object.keys(userInfo.soundcasts_managed).length > 1) {
                  history.push('/dashboard/create_bundle');
                } else {
                  this.showAlertModal({
                    content: 'You need at least 2 individual soundcasts before creating a bundle!',
                    alertOnly: true,
                  });
                }
              }}
            />
            <MuiThemeProvider>{this.renderAlertModal()}</MuiThemeProvider>
          </div>
        </div>
      </div>
    );
  }
}

SoundcastsBundles.propTypes = {
  userInfo: PropTypes.object,
  history: PropTypes.object,
  id: PropTypes.string,
};

const styles = {
  titleText: {
    fontSize: 12,
  },
  row: {
    marginTop: 10,
    marginRight: 10,
    marginBottom: 10,
    marginLeft: 0,
    backgroundColor: Colors.mainWhite,
  },
};
